import backend from '@common/backend';

const BASE = '/grades';

export const getGrades = async (query: any) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const gradeFromBE = ({ grade_type, gradeType, ...grade }: any) => ({
	...grade,
	gradeType: grade_type || gradeType,
});

export const getGrade = async (id: number) => backend.get(`${BASE}/${id}`);

export const saveGrade = async (grade_id: number, data: any) =>
	backend.put(`${BASE}/${grade_id}`, data);

export const saveGrades = async (data: any) => backend.put(`${BASE}/bulk`, data);

export const postGrades = async (data: any) => backend.post(`${BASE}/bulk`, data);

export const deleteGrade = async (id: number) => backend.delete(`${BASE}/${id}`);

export const deleteGrades = async (data: any[]) => backend.delete(`${BASE}/bulk`, data);

export const submitGrades = async (data: any) => backend.post(`${BASE}/submit`, data);

export const rejectGrade = async (grade_id: number, data: any) =>
	backend.put(`${BASE}/${grade_id}/reject`, data);

export const saveIndivGrades = async (data: any) => backend.put(`${BASE}/bulkIndiv`, data);

export const postIndivGrades = async (data: any) => backend.post(`${BASE}/bulkIndiv`, data);
